import React from 'react';
import { AlertTriangle } from 'lucide-react';

function ErrorState({ title = 'Something went wrong', message, action }) {
  return (
    <div className="state error">
      <div className="state-icon"><AlertTriangle size={24} /></div>
      <h3>{title}</h3>
      {message && <div>{message}</div>}
      {action}
    </div>
  );
}

export default ErrorState;
